import Vue from 'vue';

const state = {
  alerts: [] // 알림 배열
};

const getters = {
  alerts: state => state.alerts
};

const mutations = {
  ADD_ALERT(state, alert) {
    state.alerts.push(alert);
  },
  REMOVE_ALERT(state, alertId) {
    state.alerts = state.alerts.filter(alert => alert.id !== alertId);
  }
};

const actions = {
  addAlert({ commit }, payload = {}) {
    // 고유한 ID 생성 (타임스탬프 + 랜덤 숫자)
    const id = `${Date.now()}-${Math.random()}`;
    
    // payload에 id 추가
    const alert = {
      ...payload,
      id: payload.id || id
    };
    
    commit('ADD_ALERT', alert);

    console.log('addAlert', alert);
    if (alert.timeout > 0) {
      setTimeout(() => {
        commit('REMOVE_ALERT', alert.id);
      }, alert.timeout);
    }
  },
  removeAlert({ commit }, alertId) {
    commit('REMOVE_ALERT', alertId);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

